import { styled } from '@mui/system'
import Typography from '../../atoms/typography'
import Badge from '../badge/badge'
import Link from '../link'

const shouldForwardProp = (prop) => {
	return !['backgroundColor', 'textColor', 'position', 'notificationBackgroundColor'].includes(prop)
}

export const Label = styled(Typography)``

export const IconWrapper = styled('div')``

export const Root = styled('div', { shouldForwardProp })`
	display: flex;
	align-items: center;
	border-radius: 0px;
	text-align: center;
	font-size: 14px;
	cursor: pointer;
	margin: 0;
	background-color: ${({ backgroundColor }) => backgroundColor};
	justify-content: ${({ position }) => (position === 'right' ? 'flex-end' : 'flex-start')};
	/* overflow: hidden; */
	transition: all 0.3s ease-in;
	position: relative;
	&.faLauncherActive {
		opacity: 1;
		transition: all 0.3s ease-in;
	}
	&.faLauncherInactive {
		opacity: 0;
	}
	${Label} {
		color: ${({ textColor }) => textColor};
		position: absolute;
		z-index: -1;
		top: 0;
		height: 100%;
		display: flex;
		align-items: center;
		transition: all 0.3s ease-in;
		white-space: nowrap;
	}
	${IconWrapper} {
		background-color: ${({ backgroundColor }) => backgroundColor};
		z-index: 1;
		transition: all 0.3s ease-in;
		padding: 10px;
		display: flex;
		.MuiSvgIcon-root {
			color: ${({ textColor }) => textColor};
			transition: all 0.3s ease-in;
		}
	}
	&:hover {
		z-index: 9999;
		${Label} {
			width: auto;
			opacity: 0.75;
		}
	}
	&:hover .MuiSvgIcon-root {
		opacity: 0.75;
	}
`

export const BadgeNotification = styled(Badge, { shouldForwardProp })`
	& .MuiBadge-badge {
		background-color: ${({ notificationBackgroundColor }) => notificationBackgroundColor};
	}
`

export const LinkStyled = styled(Link, { shouldForwardProp })`
	background: unset;
	cursor: pointer;
`
